<div class="flex flex-col gap-4" #soccerMatchesContainer>
  @if(competitionMatchesActive()!== null && competitionMatchesActive()!.length >
  0){
  <div class="font-roboto-500 text-18 max-sm:text-14 mt-3 mb-2">
    {{ "MatchesToday" | translate }}
  </div>
  <!--  -->
  @for (match of competitionMatchesActive(); track match.Id; let i = $index) {
  @if (isNextMatches(match.Date) &&
  isFirstMatchOfDay(competitionMatchesActive()!, i)) {
  <app-date-label [matchDate]="match.Date" />
  }

  <!--  -->
  <app-match-by-competition-item
    [data]="match"
    [wsMatchesData]="wsMatchesData()"
  />
  } } @else {
  <!--  -->
  @if(!fetchComputed().isLoading){

  <app-no-result message="NotAvalaibleInformation" />
  } }
</div>

<div #scrollTrigger style="height: 1px"></div>

<!-- Case Loading -->
@if(fetchComputed().isLoading){
<app-skeleton-matches-list />
}
<!-- Case Error -->
@if((fetchComputed().isError && !fetchComputed().isLoading) ){
<app-no-result message="NotAvalaibleInformation" />
}
